import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';

const KlassiTechAI = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">AI Integration</h1>
          <p className="lead text-warning fw-bold">Intelligent Solutions for Your Business</p>
          <Link to="/klassitech">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiTech
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/ai" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/machine-learning.jpeg"
                  alt="Machine Learning"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Machine Learning</h3>
              <p className="text-light-50">
                Custom machine learning models to analyze data and make predictions.
                Transform your business with intelligent insights and automation.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/ai" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/natural-language-processing.jpeg"
                  alt="Natural Language Processing"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Natural Language Processing</h3>
              <p className="text-light-50">
                Advanced NLP solutions for text analysis and understanding.
                Enhance customer interactions with intelligent language processing.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/ai" className="text-decoration-none">
              <div className="p-3">
                <img
                  src="/images/computer-vision.png"
                  alt="Computer Vision"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Computer Vision</h3>
              <p className="text-light-50">
                Image and video analysis solutions powered by AI.
                Automate visual tasks and extract valuable insights.
              </p>
            </Link>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">AI Solutions Benefits</h2>
              <ul className="text-primary">
                <li className="mb-2">Increased operational efficiency</li>
                <li className="mb-2">Enhanced decision-making capabilities</li>
                <li className="mb-2">Improved customer experience</li>
                <li className="mb-2">Cost reduction through automation</li>
                <li className="mb-2">Competitive advantage in the market</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Implementation Process</h2>
              <p className="text-primary mb-4">
                Our structured approach to AI implementation:
              </p>
              <ol className="text-primary">
                <li className="mb-2">Data assessment and preparation</li>
                <li className="mb-2">Model selection and development</li>
                <li className="mb-2">Integration with existing systems</li>
                <li className="mb-2">Testing and validation</li>
                <li className="mb-2">Deployment and monitoring</li>
              </ol>
            </div>
          </Col>
        </Row>

        <div className="mt-5">
          <div className="bg-dark p-4 rounded shadow mb-4">
            <h3 className="text-light text-center mb-3">AI in Action</h3>
            <div className="text-center">
              <img 
                src="/images/LarryAI.png"
                alt="AI Solution Diagram"
                className="img-fluid rounded"
                style={{ 
                  maxWidth: '80%',
                  width: '600px',
                  height: 'auto',
                  border: '3px solid #FFD700',
                  borderRadius: '15px',
                  margin: '0 auto'
                }}
              />
              <p className="text-primary mt-2 mb-0">
                Our AI solutions combine the strengths of machine learning, natural language processing (NLP), and computer vision to build intelligent systems that transform how businesses operate. From predictive analytics and automated decision-making to real-time language understanding and visual recognition, we create adaptive technologies that learn, evolve, and deliver measurable impact.

                By integrating these advanced capabilities, we help organizations unlock new efficiencies, personalize customer experiences, and make smarter, data-driven decisions — all while staying ahead in a rapidly evolving digital landscape.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <Link to="/klassitech" className="btn btn-outline-warning">
            <i className="bi bi-arrow-left me-2"></i>
            Back to KlassiTech
          </Link>
        </div>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default KlassiTechAI; 